export let settingsPageButtonLabel = "Mp2Q_d";
export default {settingsPageButtonLabel};